import React from 'react';

// Internal modules
import type { IconProps } from './types';

export const ShieldLockSpot = ({
  bgColor,
}: IconProps = {}): React.ReactElement => (
  <svg
    fill="none"
    height="48"
    viewBox="0 0 49 48"
    width="49"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5895_28926)">
      <circle cx="24.3825" cy="24" fill={bgColor || '#F7F5F0'} r="24" />
      <g clipPath="url(#clip1_5895_28926)">
        <path
          d="M38.6246 14.9634C30.2926 14.2456 25.6346 10.8834 25.5622 10.8184C24.9795 10.3939 24.1437 10.3939 23.5609 10.8184C23.524 10.8516 18.8677 14.2456 10.4986 14.9634C9.69838 15.0284 9.08008 15.6493 9.08008 16.3671C9.08008 35.3633 23.3436 41.1402 23.9618 41.3699C24.1807 41.435 24.3626 41.5 24.5801 41.5C24.799 41.5 25.0164 41.4669 25.1983 41.3699C25.8167 41.1417 40.0801 35.3649 40.0801 16.3671C40.0446 15.6493 39.4248 15.0284 38.6246 14.9634Z"
          fill="#D89700"
        />
        <path
          d="M38.1715 14.3194C30.1083 13.6247 25.6006 10.371 25.5305 10.3082C24.9666 9.89728 24.1578 9.89728 23.5938 10.3082C23.558 10.3402 19.052 13.6248 10.9528 14.3194C10.1784 14.3823 9.58006 14.9832 9.58006 15.6779C9.58006 34.0612 23.3834 39.6518 23.9817 39.8741C24.1935 39.9371 24.3696 40 24.5801 40C24.7919 40 25.0023 39.9679 25.1784 39.8741C25.7768 39.6533 39.5801 34.0628 39.5801 15.6779C39.5457 14.9832 38.9459 14.3823 38.1715 14.3194Z"
          fill="#F9B822"
        />
        <path
          d="M29.7498 37.1623C33.9717 33.9173 39.5801 27.3968 39.5801 15.6779C39.5457 14.9832 38.9459 14.3823 38.1715 14.3194C30.1083 13.6247 25.6006 10.371 25.5305 10.3082C24.9666 9.89728 24.1578 9.89728 23.5938 10.3082C23.5598 10.3386 19.4964 13.3008 12.1543 14.1948C11.9561 15.3054 11.8527 16.4481 11.8527 17.6144C11.8527 27.7717 19.6925 36.1295 29.7498 37.1623Z"
          fill="#FED13C"
        />
        <path
          clipRule="evenodd"
          d="M26.7767 19.9971V22.475H22.8846V19.9971C22.8846 18.9707 23.7558 18.1387 24.8306 18.1387C25.9054 18.1387 26.7767 18.9707 26.7767 19.9971ZM20.9385 31.1476H24.8306H28.7228C29.4393 31.1476 30.0202 30.5929 30.0202 29.9086V23.7139C30.0202 23.0296 29.4393 22.475 28.7228 22.475V19.9971C28.7228 17.9444 26.9802 16.2803 24.8306 16.2803C22.6811 16.2803 20.9385 17.9444 20.9385 19.9971V22.475C20.2219 22.475 19.6411 23.0296 19.6411 23.7139V29.9086C19.6411 30.5929 20.2219 31.1476 20.9385 31.1476ZM24.8306 28.0502C25.5472 28.0502 26.128 27.4955 26.128 26.8113C26.128 26.127 25.5472 25.5723 24.8306 25.5723C24.1141 25.5723 23.5332 26.127 23.5332 26.8113C23.5332 27.4955 24.1141 28.0502 24.8306 28.0502Z"
          fill="#D89700"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M26.2157 19.7168V22.1947H22.3235V19.7168C22.3235 18.6904 23.1948 17.8584 24.2696 17.8584C25.3444 17.8584 26.2157 18.6904 26.2157 19.7168ZM20.3775 30.8673H24.2696H28.1618C28.8783 30.8673 29.4591 30.3126 29.4591 29.6283V23.4336C29.4591 22.7494 28.8783 22.1947 28.1618 22.1947V19.7168C28.1618 17.6641 26.4192 16 24.2696 16C22.12 16 20.3775 17.6641 20.3775 19.7168V22.1947C19.6609 22.1947 19.0801 22.7494 19.0801 23.4336V29.6283C19.0801 30.3126 19.6609 30.8673 20.3775 30.8673ZM24.2696 27.7699C24.9862 27.7699 25.567 27.2153 25.567 26.531C25.567 25.8467 24.9862 25.2921 24.2696 25.2921C23.5531 25.2921 22.9722 25.8467 22.9722 26.531C22.9722 27.2153 23.5531 27.7699 24.2696 27.7699Z"
          fill="#142C8E"
          fillRule="evenodd"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_5895_28926">
        <rect
          fill="white"
          height="48"
          transform="translate(0.382511)"
          width="48"
        />
      </clipPath>
      <clipPath id="clip1_5895_28926">
        <rect
          fill="white"
          height="33.3398"
          transform="translate(9.08008 10)"
          width="31"
        />
      </clipPath>
    </defs>
  </svg>
);
